import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { URL } from "../../Redux/common/url";
import Api from "../../Redux/common/api";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import moment from "moment";
const SchemeWisePdfPlot = ({ details }) => {
  const printRef = useRef();
  const { id } = useParams();
  const jsonData = [
    { id: 1, name: "Product A", quantity: 2, price: 500 },
    { id: 2, name: "Product B", quantity: 1, price: 1500 },
    { id: 3, name: "Product C", quantity: 3, price: 300 },
  ];
  const [propertydata, setpropertydata] = useState([]);
  const calculateTotal = () => {
    return jsonData.reduce((acc, item) => acc + item.quantity * item.price, 0);
  };
  console.log(details);

  const handlePrint = () => {
    const element = printRef.current;
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.autoPrint(); // Automatically trigger print dialog
      window.open(pdf.output("bloburl"), "_blank"); // Open in new tab
    });
  };
  const hendleDelete = (e) => {
    console.log(e);

    return () => {};
  };

  //   const hendleToPrint = async (e) => {
  //     console.log("print");
  //     return;
  //   };
  useEffect(() => {
    hendleToPrint();

    return () => {};
  }, []);

  const hendleToPrint = async () => {
    const token = localStorage.getItem("admin_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const formData = {};
    if (id) {
      formData.schemeId = id;
    }
    const response = await Api.post(
      `${URL.getcateAllProperty}`,
      formData,
      config
    );
    const data = response.data?.data;

    if (data.length === 0) {
      //   toast.error("No Schemes found");
    } else {
      let schemes = data.map((item) => {
        return {
          ["Scheme Name"]: item?.skimName,
          ["Onwer Name"]: item?.fullName,
          ["Father's/Husband's Name"]: item?.fatharYaHusband,
          ["Address"]: item?.Address,
          ["Area"]: item?.area,
          ["Plot/Shop No."]: item?.number,
          ["Type"]: item?.type,
          ["Recept No."]: item?.rasidNo,
          ["lengthWidth"]: item?.lengthWidth,
          ["Sold"]: item?.sold,
          ["Sale Date"]: item?.sellinDate
            ? moment(item?.sellinDate).format(" DD/MM/YYYY ")
            : "",
          ["Transafard"]: item?.transferred,
        };
      });

      setpropertydata(schemes);
    }
    return;
  };
  return (
    <div>
      <div
        style={{
          display: "none",
          padding: "20px",
          background: "#fff",
          maxWidth: "800px",
        }}
      >
        <div
          ref={printRef}
          style={{
            padding: "25px",
          }}
        >
          <div
            style={{
              borderTop: "1px solid #ccc",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h6>Reg. No. 2546/L</h6>
          </div>

          <div style={{ textAlign: "center", borderBottom: "1px solid #ccc" }}>
            <p style={{ marginBottom: "0px" }}>
              Kant Adarsh Graha Nirman Sahakari Samti Ltd. Jaipur{" "}
            </p>
          </div>
          <div style={{ textAlign: "center", borderBottom: "1px solid #ccc" }}>
            <p style={{ marginBottom: "0px" }}>{details?.Scheme?.name} </p>
          </div>
          {/* <p style={{ marginBottom: "0px" }}>
            Date: {new Date().toLocaleDateString()}
          </p> */}
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  S. No
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Scheme Name
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Onwer Name
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Father's/Husband's Name
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Address
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Plot No.
                </th>

                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  L x W Feet
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Area Sq. Gaj
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Type
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Recept No.
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Sold
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Sale Date
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "1px",
                    fontSize: "11px",
                  }}
                >
                  Transafard
                </th>
              </tr>
            </thead>
            <tbody>
              {propertydata.map((item, index) => {
                console.log(item);
                return (
                  index < 500 && (
                    <tr key={index}>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          textAlign: "center",
                          fontSize: "11px",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          fontSize: "12px",
                        }}
                      >
                        {item["Scheme Name"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "center",

                          fontSize: "12px",
                        }}
                      >
                        {item["Onwer Name"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "center",
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        {item["Father's/Husband's Name"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "center",
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        {item["Address"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        {item["Plot/Shop No."]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        {item["lengthWidth"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        {item["Area"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {item["Type"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {item["Recept No."]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {item["Sold"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {item["Sale Date"]}
                      </td>
                      <td
                        style={{
                          border: "1px solid #ccc",
                          padding: "1px",
                          //   textAlign: "right",
                          fontSize: "12px",
                        }}
                      >
                        {item["Transafard"]}
                      </td>
                    </tr>
                  )
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan="12"
                  style={{
                    border: "1px solid #ccc",
                    padding: "2px",
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                >
                  Creato Software
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "2px",
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                ></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <ReactToPrint
        trigger={() => (
          <Button variant="primary" className="mb-5" onClick={hendleDelete}>
            Print / Download
          </Button>
        )}
        content={() => {
          hendleToPrint();
          return printRef.current;
        }}
      />
      {/* <button
        onClick={handlePrint}
        style={{ marginTop: "20px", padding: "10px 20px", cursor: "pointer" }}
      >
        Print Invoice
      </button> */}
    </div>
  );
};

export default SchemeWisePdfPlot;
